module.exports = __webpack_public_path__ + "img/hotelFamily-9.33358956.jpg";